








import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'
import { EStatusType } from '@/components/statuses/EStatusType'

@Component({
  props: {
    type: {
      type: String as PropType<EStatusType>
    }
  }
})
export default class Status extends Vue {
}
